module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.8457/images/homepage/corner-blobs.png"